import { render, staticRenderFns } from "./ArrowExpand.vue?vue&type=template&id=8d012b7a&"
import script from "./ArrowExpand.vue?vue&type=script&lang=js&"
export * from "./ArrowExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports